export const MAX_ESTABLISHMENT_NAME_LENGTH = 255
export const MAX_SHORT_NAME_LENGTH = 255
export const UAI_LENGTH = 16
export const MAX_EMAIL_LENGTH = 255
export const MAX_PHONE_LENGTH = 32
export const MAX_STREET_LENGTH = 255
export const MAX_CITY_LENGTH = 128
export const MAX_POSTAL_CODE_LENGTH = 16

export const ESTABLISHMENT_ERRORS = {
  NOT_FOUND: 'Établissement non trouvé',
  ALREADY_DELETED: 'Établissement déjà supprimé',
  NOT_ACCESSIBLE: 'Établissement non accessible',
  INVALID_UAI: 'Code UAI invalide',
  INVALID_EMAIL: 'Email invalide',
  INVALID_TYPE: "Type d'établissement invalide",
  UAI_ALREADY_EXISTS: 'Ce code UAI existe déjà',
  CREATION_FAILED: 'Erreur lors de la création',
  UPDATE_FAILED: 'Erreur lors de la mise à jour',
  DELETE_FAILED: 'Erreur lors de la suppression',
} as const

export const ESTABLISHMENT_OPERATIONS = {
  CREATE: 'create_establishment',
  FIND_ALL: 'findMany_establishments',
  FIND_ALL_PAGINATED: 'findMany_paginated_establishments',
  FIND_ONE: 'findOne_establishment',
  UPDATE: 'update_establishment',
  DELETE: 'delete_establishment',
} as const

export const ESTABLISHMENT_LOG_MESSAGES = {
  CREATING: (userId: string, name: string) =>
    `[User ${userId}] Création établissement: ${name}`,
  CREATED: (id: string) => `Establishment created successfully: ${id}`,
  UPDATING: (userId: string, id: string) =>
    `[User ${userId}] Mise à jour établissement: ${id}`,
  UPDATED: (id: string) => `Establishment updated successfully: ${id}`,
  DELETING: (userId: string, id: string) =>
    `[User ${userId}] Suppression établissement: ${id}`,
  DELETED: (id: string) => `Establishment deleted successfully: ${id}`,
  FOUND: (count: number, userId: string) =>
    `Found ${count} establishments for user ${userId}`,
} as const

export const ESTABLISHMENT_ERROR_CONTEXTS = {
  CREATE: 'create establishment',
  FETCH_ALL: 'fetch establishments',
  FETCH_ALL_PAGINATED: 'fetch establishments paginated',
  FETCH_ONE: 'fetch establishment',
  UPDATE: 'update establishment',
  DELETE: 'delete establishment',
} as const

export const ESTABLISHMENT_POLICY_ACTIONS = {
  CREATE: 'establishment:create',
  VIEW: 'establishment:view',
  UPDATE: 'establishment:update',
  DELETE: 'establishment:delete',
} as const
